import React from 'react';

const About = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">About Us</h2>

      <div className="grid gap-6">
        <div className="p-6 rounded-lg border bg-white border-gray-200 dark:bg-gray-800 dark:border-gray-700">
          <h3 className="text-xl font-semibold mb-2">INTELLIGENT MARKET PREDICTIONS POWERED BY AI</h3>
          <p className="text-sm text-gray-700 dark:text-gray-300">
            BorsAI is an AI-powered forecasting platform that analyzes a wide range of market indicators, asset trends, sentiment signals, and macroeconomic data. It delivers data-driven insights across leading NYSE, NASDAQ, and cryptocurrency assets.
          </p>
          <p className="text-sm text-gray-700 dark:text-gray-300">
            All predictions on this platform are generated entirely by automated AI models — they are NOT reviewed, curated, or endorsed by human analysts before publication.
          </p>
        </div>

        <div className="p-6 rounded-lg border bg-white border-gray-200 dark:bg-gray-800 dark:border-gray-700">
          <h3 className="text-lg font-semibold mb-3">TECHNICAL EDGE</h3>
          <ul className="list-disc list-outside mx-14 text-left space-y-2 text-sm text-gray-700 dark:text-gray-300">
            <li>
              <strong>AI Models:</strong> Our models are trained on diverse data streams for deep, multidimensional market analysis
            </li>
            <li>
              <strong>Data Integrity:</strong> A multi-layered validation pipeline ensures clean and consistent data inputs
            </li>
            <li>
              <strong>Daily Predictions:</strong> Updates are published daily before markets open, providing the latest outlooks
            </li>
            <li>
              <strong>Transparent Performance:</strong> Explore model accuracy and performance metrics anytime on our Predictions page
            </li>
          </ul>
          <p className="mt-4 text-sm text-gray-700 dark:text-gray-300">
            While providing sophisticated market predictions, BorsAI does not offer investment advice or establish advisory relationships.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
